import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/browser";
import { onCLS, onFID, onLCP, onFCP, onTTFB } from 'web-vitals';

export const initializeMonitoring = () => {
  // Initialize Sentry
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      new BrowserTracing({
        tracePropagationTargets: ["localhost", "groklymed.me"],
      }),
    ],
    tracesSampleRate: 1.0,
    environment: import.meta.env.MODE,
  });

  // Web Vitals reporting
  const reportWebVital = ({ name, value, id }: { name: string, value: number, id: string }) => {
    // Report to Sentry
    Sentry.captureMessage(`Web Vital: ${name}`, {
      level: "info",
      extra: {
        id,
        value,
      },
    });

    // Log to console in development
    if (import.meta.env.DEV) {
      console.log(`Web Vital: ${name}`, { id, value });
    }
  };

  // Initialize individual web vitals
  onCLS(reportWebVital);
  onFID(reportWebVital);
  onLCP(reportWebVital);
  onFCP(reportWebVital);
  onTTFB(reportWebVital);
};

export const trackError = (error: Error, context?: Record<string, any>) => {
  Sentry.captureException(error, {
    extra: context,
  });
};

export const trackEvent = (name: string, data?: Record<string, any>) => {
  Sentry.captureMessage(name, {
    level: "info",
    extra: data,
  });
};